export default "__VITE_ASSET__BMW1CPxz__"